import styled from 'styled-components'

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`

export const Row = styled.div`
  padding: 10px;
  justify-content: center;
  display: flex;
  flex-direction: row;
`

export const BallContainer = styled.div`
  max-width: 500px;
  flex-wrap: wrap;
`

export const Ball = styled.div`
  margin: 5px;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  border: rgba(0, 0, 0, 0) 3px solid;
  cursor: pointer;

  &:hover {
    border: blue 3px solid;
  }
`

export const Canvas = styled.canvas`
  background: #eee;
  display: block;
  margin: 0 auto;
`

export const GameCanvas = styled(Canvas)`
  cursor: none;
`
